import Spin from 'antd/es/spin';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { styled } from 'styled-components';

import { useSessionUser } from '../../contexts/SessionUserContext';
import { useLogout } from '../../queries/authentication';
import { logger } from '../../utils/logger';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: ${({ theme }) => theme.marginLG}px;
`;

const StyledText = styled.div`
  font-size: ${({ theme }) => theme.fontSize}px;
  color: ${({ theme }) => theme.colorTextSecondary};
`;

export const LogoutPage = () => {
  const { userId } = useSessionUser();
  const navigate = useNavigate();
  const logoutMutation = useLogout();
  const hasStartedLogout = useRef(false);

  logger.debug('LogoutPage render', {
    userId,
    hasStartedLogout: hasStartedLogout.current,
    mutationStatus: logoutMutation.status,
  });

  // Trigger logout once when component mounts
  useEffect(() => {
    if (!hasStartedLogout.current) {
      logger.info('Starting logout mutation');
      hasStartedLogout.current = true;
      logoutMutation.mutate(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty deps - run once on mount

  // Redirect when user becomes unauthenticated (after successful logout)
  useEffect(() => {
    if (!userId) {
      logger.info('User is logged out, redirecting to login');
      void navigate('/auth/login', { replace: true });
    }
  }, [userId, navigate]);

  // Show spinner while logging out
  return (
    <StyledContainer>
      <Spin size="large" />
      <StyledText>Logging you out...</StyledText>
    </StyledContainer>
  );
};
